import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const RevenueForecasting = ({ data }) => {
  const chartData = Object.keys(data || {})?.map(service => ({
    service: service?.replace(' ', '\n'),
    consultations: data?.[service]?.consultations,
    activeDeals: data?.[service]?.activeDeals,
    forecastedRevenue: parseFloat(data?.[service]?.forecastedRevenue || 0),
    avgDealSize: parseFloat(data?.[service]?.avgDealSize || 0)
  }));

  return (
    <div className="bg-white rounded-xl shadow-elevation-1 p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-foreground mb-1">Revenue Forecasting by Service Type</h3>
          <p className="text-sm text-muted-foreground">Projected revenue and deal metrics</p>
        </div>
        <div className="w-10 h-10 bg-purple-50 rounded-lg flex items-center justify-center">
          <Icon name="DollarSign" size={20} className="text-purple-600" />
        </div>
      </div>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="service" />
          <YAxis yAxisId="left" orientation="left" stroke="#8B5CF6" />
          <YAxis yAxisId="right" orientation="right" stroke="#1FB5A5" />
          <Tooltip 
            content={({ active, payload }) => {
              if (active && payload && payload?.length) {
                return (
                  <div className="bg-white p-4 rounded-lg shadow-lg border border-gray-200">
                    <p className="font-semibold text-foreground mb-2">{payload?.[0]?.payload?.service?.replace('\n', ' ')}</p>
                    <p className="text-sm text-muted-foreground">Consultations: {payload?.[0]?.payload?.consultations}</p>
                    <p className="text-sm text-muted-foreground">Active Deals: {payload?.[0]?.payload?.activeDeals}</p>
                    <p className="text-sm text-purple-600 font-medium">Forecasted: ${payload?.[0]?.payload?.forecastedRevenue?.toLocaleString()}</p>
                    <p className="text-sm text-[#1FB5A5] font-medium">Avg Deal: ${payload?.[0]?.payload?.avgDealSize?.toLocaleString()}</p>
                  </div>
                );
              }
              return null;
            }}
          />
          <Legend />
          <Bar yAxisId="left" dataKey="forecastedRevenue" fill="#8B5CF6" name="Forecasted Revenue ($)" radius={[8, 8, 0, 0]} />
          <Bar yAxisId="right" dataKey="activeDeals" fill="#1FB5A5" name="Active Deals" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-4 gap-4">
        {Object.keys(data || {})?.map((service, index) => (
          <div key={index} className="bg-gray-50 rounded-lg p-4">
            <p className="text-sm font-semibold text-foreground mb-2">{service}</p>
            <p className="text-xs text-muted-foreground mb-1">Consultations: {data?.[service]?.consultations}</p>
            <p className="text-xs text-muted-foreground mb-1">Active Deals: {data?.[service]?.activeDeals}</p>
            <p className="text-sm font-bold text-purple-600">${parseFloat(data?.[service]?.forecastedRevenue || 0)?.toLocaleString()}</p>
            <p className="text-xs text-[#1FB5A5]">Avg: ${parseFloat(data?.[service]?.avgDealSize || 0)?.toLocaleString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RevenueForecasting;